const urlForPostEdit = ({ postId, kitId, prefix }) => {
	let url = `/post/edit?kitId=${kitId}${postId ? `&postId=${postId}` : ''}`
	if (prefix) {
		url = (prefix[prefix.length - 1] === '/' ? prefix.substr(0, prefix.length - 1) : prefix) + url
	}
	return url
}

export default urlForPostEdit



// WEBPACK FOOTER //
// ./src/utilities/urlForPostEdit.js